import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const PaginatorContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .first {
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
        width: 70px;
    }
    
    .last {
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        width: 70px;
    }
    
`;

export const Item = styled.div`
    width: 30px;
    height: 30px;
    /* border: 1px solid ${theme.colors.green.Bandeira}; */
    display: flex;
    flex-direction: ${props => props.isOpen ? 'column' : 'row'};
    align-items: center;
    justify-content: ${props => props.isOpen ? 'flex-start' : 'center'};

    border-radius: ${props => props.isActive ? '50%' : '0px'};

    background-color: ${props => props.isActive ? '#589BFF29' : 'transparent'};
    cursor: ${props => props.isDisabled ? 'default' : 'pointer'};
    pointer-events: ${props => props.isDisabled ? 'none' : 'auto'};

    label {
        margin: 0px;
        color:${props => props.isDisabled ? theme.colors.disabled.Desabilitado_Medio : `${theme.colors.blue.Azul_link}`};
        font-size: ${theme.typography.fontSize.tagLineM};
        font-weight: ${theme.typography.fontWeight.extraBold};

        &::selection{
            background: transparent;
        }
    }

    .more {
        width: ${props => props.isOpen ? '50px' : 'auto'};
        height: ${props => props.isOpen ? '40px' : 'auto'};
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    transition: all 0.15s ease-in;
`;


export const DropItem = styled.div`
    width: 50px;
    height: 40px;
    border-bottom: 1px solid ${theme.colors.blue.Azul_link};
    display: flex;
    flex-direction: ${props => props.isOpen ? 'column' : 'row'};
    align-items: center;
    justify-content: ${props => props.isOpen ? 'flex-start' : 'center'};
    background-color: ${props => props.isActive ? `${theme.colors.blue.Azul_link}` : '#f8f8f9'};

    label {
        margin: 0px;
        color: ${props => props.isActive ? `${theme.colors.white.Branco}` : `${theme.colors.blue.Azul_link}`};
        font-size: 65%;

        &::selection{
            background: transparent;
        }
    }


    &:hover {
        background-color: ${props => props.isActive ? `${theme.colors.blue.Azul_link}` : 'rgba(88, 155, 255, 0.2)'};
    }
    
    &:active {
        background-color: ${props => props.isActive ? `${theme.colors.blue.Azul_link}` : 'rgba(88, 155, 255, 0.6)'};
    }

    transition: all 0.15s ease-in;
`;

export const Options = styled.div`
    width: 106%;
    max-height: 100px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    border: 1px solid ${theme.colors.blue.Azul_link};
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    position: relative;
    /* O dropdown sobe por cima do que esta acima do paginador (margin-top
       negativo). Sem z-index ele ficava atras da barra de rolagem falsa da
       TableWithLabelBlackV2, que e position: sticky com z-index: 4. */
    z-index: 10;
    overflow: scroll;
    margin-top: ${props => (
        props.opLength === 1 ? '-40px' :
            props.opLength === 2 ? '-75px' :
                props.opLength >= 3 ? '-100px' : '0px'
    )};
    background-color: #f8f8f9;


    &::selection{
        background: transparent;
    }

    /* width */
    &::-webkit-scrollbar {
        width: 0px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    
    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: #589bff; 
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #589bff; 
    }

    overflow-x: hidden !important;
    label {
        margin: 0px;
        height: 30px;
        color: ${props => props.isActive ? `${theme.colors.white.Branco}` : `${theme.colors.blue.Azul_link}`};
        font-size: 65%;
    }

    transition: all 0.15s ease-in;
`;

export const ContainerPage = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >p{
        text-align: center;

        font-size: 9px;
    }
`;

export const Legenda = styled.p`
    text-align: center;
    font-size: 65%;
    margin-top: 10px;
`;
